module.exports = __webpack_public_path__ + "static/media/e67d31bf.jpg";